import { useIMask } from "react-imask";
import { useFormContext } from "react-hook-form";

import TextField from "./text-field";

import { validation } from "../../Utils/validations";

import { phoneNumberMask } from "../../Utils/constants";

import { removeControlCharacters } from "../../Utils/helpers";

export default function PhoneNumber(props) {
  const { register, getFieldState, formState } = useFormContext();

  const phoneNumberInputProps = register("phoneNumber", {
    required: "Please enter your phone number",
    validate: (phoneNumber) => {
      // Validate that phone number has exactly 10 digits (stripped of formatting)
      const isValid = validation.number.is10DigitPhoneNumber(phoneNumber);
      return isValid || "Your phone number should be 10 digits long";
    },
  });

  const { ref } = useIMask(
    {
      mask: phoneNumberMask,
      eager: true,
    },
    {
      onAccept: (value) =>
        phoneNumberInputProps.onChange?.({ target: { name: "phoneNumber", value: removeControlCharacters(value) } }),
    }
  );

  const { error: phoneNumberFieldError } = getFieldState(phoneNumberInputProps.name, formState);

  return (
    <TextField
      {...phoneNumberInputProps}
      ref={(ele) => {
        ref.current = ele;
        phoneNumberInputProps.ref(ele);
      }}
      onBlur={(e) =>
        phoneNumberInputProps.onBlur({
          target: { name: "phoneNumber", value: removeControlCharacters(e.target.value) },
        })
      }
      label="Phone"
      autoFocus
      errorMessage={phoneNumberFieldError?.message}
      error={!!phoneNumberFieldError}
      {...props}
    />
  );
}
